//Creates new Box and assigns ID and type
export const createBox = (data) => {
    //data = {id, type}
    return { type: "CREATE_BOX", payload: data}
}

//Set if pipette controls are visible or not
export const setBoxHeld = (data) => {
    //data = {id, held}
    return { type: "SET_BOX_HELD", payload: data}
}

//Set whether the pipette controls are displayed or not
export const setBoxControlVisibility = (data) => {
    //data = {id, animatingOut}
    return { type: "SET_BOX_CONTROLS_VISIBLE", payload: data}
  }

  export const setBoxesInScene = data => {
    //data = {type, inScene}
    return { type: "SET_BOX_IN_SCENE", payload: data };
  };